export const DELIVERY_QUICK_FILTERS_NAME = 'delivery-quick-filters';

export const PRODUCT_CONTAINER_WRAPPER = 'product_container__wrapper';
export const PRODUCTS_GRID_WRAPPER = 'products_grid__wrapper';
